import React, { FC, ReactNode } from 'react';
import PopupContainer from 'shared/components/PopupContainer';

type PopupMainProps = {
	children?: ReactNode;
	setIsShowPopup: React.Dispatch<React.SetStateAction<boolean>>;
	isDisablePadding?: boolean;
};

const PopupMain: FC<PopupMainProps> = ({ children, setIsShowPopup, isDisablePadding }: PopupMainProps) => {
	return (
		<PopupContainer setIsShowPopup={setIsShowPopup} isDisablePadding={isDisablePadding}>
			{children}
		</PopupContainer>
	);
};

export default PopupMain;
